
const atlas_look = {
    namespaced: true,
    state: {
        all_list: [],
        now_item: null,
        is_Show: false
    },
    mutations: {
        SET_all_list(state, arr) {
            state.all_list = arr
        },
        SET_now_item(state, obj) {
            state.now_item = obj
        },
        SET_is_Show(state, val) {
            state.is_Show = val
        },

    }
};

export default atlas_look;



// WEBPACK FOOTER //
// ./src/vuex/modules/atlas_look.js